import { useQuery } from '@tanstack/react-query';
import { api } from '../lib_api';

function item(label: string, value: any, warning = false) {
  return (
    <div className="panel p-4">
      <p className="text-sm text-mutedGray dark:text-darkTextSecondary">{label}</p>
      <p className={`mt-1 text-sm ${warning ? 'text-amber-600' : 'text-darkText dark:text-darkTextPrimary'}`}>{String(value ?? 'Not available')}</p>
    </div>
  );
}

export default function RuntimeMonitor() {
  const health = useQuery({ queryKey: ['admin', 'runtime', 'health'], queryFn: async () => (await api.get('/api/health')).data, refetchInterval: 30000 });
  const runtime = useQuery({ queryKey: ['admin', 'runtime', 'system'], queryFn: async () => (await api.get('/api/system/status')).data, refetchInterval: 30000 });
  const macro = useQuery({ queryKey: ['admin', 'runtime', 'macro'], queryFn: async () => (await api.get('/api/macro/status?symbol=XAUUSD')).data, refetchInterval: 30000 });

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {item('Trader Service Health', health.data?.dependencies?.pythonTrader?.ready ? 'Healthy' : 'Unavailable', !health.data?.dependencies?.pythonTrader?.ready)}
      {item('Backend Health', health.data?.status)}
      {item('Latest Account Snapshot', runtime.data?.lastExecutionAttempt?.timestamp || 'Not exposed by backend yet')}
      {item('Latest Strategy Evaluation Timestamp', runtime.data?.decisionStatus?.timestamp || 'Not exposed by backend yet')}
      {item('Latest Signal Timestamp', runtime.data?.lastExecutionAttempt?.signalAt || 'Not exposed by backend yet')}
      {item('Macro Feed Status', `${macro.data?.feedStatus || 'unknown'} / ${macro.data?.mode || 'unknown'}`, macro.data?.feedStatus === 'unavailable')}
      {item('Runtime Warnings', runtime.data?.blockedReasons?.length ? runtime.data.blockedReasons.join(', ') : 'No current runtime blockers', !!runtime.data?.blockedReasons?.length)}
    </div>
  );
}
